export const heroData = {
  tags: ['每日更新', '高清画质', '下拉式阅读'],
  slogan: '全网热门漫画，一网打尽，追更不等待',
  description: '羞羞漫画网是国内领先的韩漫、日漫、国漫在线免费阅读平台，汇集全网最全热门漫画资源。平台每日同步更新最新话，支持流畅下拉式阅读体验，无论你是韩漫爱好者、日漫迷还是国漫粉丝，这里都能找到心仪的作品。无需注册登录，打开即看，高清画质畅享每一页漫画细节。目前热门连载作品包括《秘密教学》《傀儡》《健身教练》《女神狩猎》等，更有海量完结作品供你一次性看过瘾。',
  stats: [
    { label: '每日更新', value: '200+' },
    { label: '收录作品', value: '5000+' },
    { label: '累计读者', value: '800万+' },
  ],
  primaryCta: { label: '开始阅读', href: '#index' },
  secondaryCta: { label: '热门榜单', href: '#ranking' },
};

export const updatesData = [
  {
    date: '2026-07-29',
    title: '《秘密教学》第128话更新',
    summary: '姐姐的秘密终于被发现，剧情迎来重大转折点，本话信息量巨大不容错过。',
    tag: '韩漫热更',
  },
  {
    date: '2026-07-28',
    title: '新作上架：《邻家姐姐》',
    summary: '高人气韩漫新作正式登陆平台，细腻画风搭配悬疑剧情，开篇即高能。',
    tag: '新作推荐',
  },
  {
    date: '2026-07-27',
    title: '《女神狩猎》第55话',
    summary: '剧情反转震撼来袭，主角身份终于揭晓，读者评论区炸开了锅。',
    tag: '剧情爆点',
  },
  {
    date: '2026-07-26',
    title: '日漫专区：经典佳作全收录',
    summary: '《进击的巨人》《鬼灭之刃》《咒术回战》等热门日漫全篇上线，一次看个够。',
    tag: '日漫精选',
  },
  {
    date: '2026-07-25',
    title: '国漫推荐：《斗破苍穹》年番',
    summary: '国产漫画年度力作持续热更，精美国风画质收获读者一致好评。',
    tag: '国漫力作',
  },
  {
    date: '2026-07-24',
    title: '《健身教练》第92话已更新',
    summary: '健身房里的故事越来越精彩，本周双更福利，读者直呼过瘾。',
    tag: '人气连载',
  },
  {
    date: '2026-07-23',
    title: '本周排行榜更新发布',
    summary: '《傀儡》强势登顶本周热榜榜首，《继母的朋友们》紧随其后，竞争激烈。',
    tag: '榜单速递',
  },
];

export const contactData = {
  title: '投稿与合作',
  description: '如果你是漫画作者或版权方，欢迎通过以下方式与我们联系。我们致力于为创作者提供优质的展示平台，共同打造更好的漫画阅读体验。',
  email: 'contact@xiuxiumanhua.com',
  qq: '1234567890',
};

export const mediaData = [
  {
    title: '《傀儡》精彩片段',
    description: '年度最热韩漫，悬疑剧情层层递进，每一话都让人欲罢不能。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20warm%20toned%20manga%20illustration%20scene%20with%20soft%20atmospheric%20lighting%2C%20artistic%20comic%20book%20aesthetic%20with%20rich%20warm%20colors%2C%20captivating%20mood%20and%20composition%2C%20minimalist%20background%20with%20gentle%20gradients%20and%20textured%20brush%20strokes%2C%20editorial%20art%20style&width=640&height=360&seq=media-card-01&orientation=landscape',
    tag: '热播推荐',
  },
  {
    title: '《秘密教学》名场面',
    description: '经典韩漫名场面回顾，那些令人心跳加速的瞬间你还记得吗？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20warm%20atmospheric%20manga%20art%20scene%20with%20gentle%20lighting%2C%20romantic%20comic%20illustration%20aesthetic%20in%20warm%20coral%20and%20cream%20tones%2C%20elegant%20composition%20with%20flowing%20lines%20and%20minimalist%20background%2C%20artistic%20editorial%20style&width=640&height=360&seq=media-card-02&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '《女神狩猎》预告',
    description: '最新话即将上线，先来看看精彩预告，准备好迎接剧情暴击。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20manga%20style%20illustration%20with%20warm%20atmospheric%20lighting%2C%20fantasy%20comic%20art%20aesthetic%20with%20golden%20amber%20highlights%2C%20dynamic%20composition%20on%20soft%20gradient%20background%2C%20artistic%20brush%20texture%20with%20captivating%20mood&width=640&height=360&seq=media-card-03&orientation=landscape',
    tag: '即将上线',
  },
];

export const featuresData = [
  {
    icon: 'ri-book-open-line',
    title: '完全免费',
    description: '全站漫画永久免费阅读，无需付费订阅即可畅享海量正版漫画资源，日漫韩漫国漫一网打尽。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日追更',
    description: '热门作品每日同步更新，第一时间追到最新话，与全网读者同步讨论剧情发展。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    description: '全部漫画采用高清数字扫描与优化处理，画面清晰锐利，细节纤毫毕现。',
  },
  {
    icon: 'ri-arrow-down-double-line',
    title: '下拉式阅读',
    description: '专为移动端优化的下拉式阅读体验，流畅丝滑不卡顿，单手操作轻松追漫。',
  },
];

export const indexData = [
  { title: '韩漫专区', icon: 'ri-global-line', description: '韩国热门漫画精选合集', href: '#ranking' },
  { title: '日漫专区', icon: 'ri-sun-line', description: '经典日本漫画全收录', href: '#carousel' },
  { title: '国漫专区', icon: 'ri-flag-2-line', description: '国产漫画精品推荐', href: '#cards' },
  { title: '完结作品', icon: 'ri-check-double-line', description: '一次看完整部漫画', href: '#features' },
  { title: '连载热榜', icon: 'ri-fire-line', description: '当前最热连载排行', href: '#ranking' },
  { title: '新作推荐', icon: 'ri-sparkling-2-line', description: '最新上架漫画优先看', href: '#media' },
  { title: '分类浏览', icon: 'ri-grid-line', description: '按类型找到你喜欢的', href: '#topics' },
];

export const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20style%20male%20character%20avatar%20portrait%20with%20soft%20warm%20lighting%20on%20simple%20background%2C%20digital%20art%20illustration%20style%20with%20clean%20lines%20and%20warm%20tones&width=120&height=120&seq=avatar-comment-01&orientation=squarish',
    name: '漫画迷小王',
    time: '2小时前',
    content: '《秘密教学》真的太绝了！每一话都在期待下一话，作者的剧情把控能力太强了。画面也很精美，这个平台阅读体验一级棒。',
    work: '在读《秘密教学》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20female%20character%20portrait%20avatar%20with%20gentle%20warm%20lighting%20on%20simple%20minimal%20background%2C%20digital%20art%20illustration%20with%20soft%20features%20and%20warm%20color%20palette&width=120&height=120&seq=avatar-comment-02&orientation=squarish',
    name: '追漫达人',
    time: '5小时前',
    content: '强烈推荐《傀儡》！这部漫画的悬疑感和反转真的绝了，画风也是天花板级别。每天刷新等更新已经成了习惯，感谢平台。',
    work: '在读《傀儡》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20young%20adult%20character%20portrait%20avatar%20with%20casual%20expression%20on%20simple%20gradient%20background%2C%20modern%20digital%20art%20illustration%20with%20warm%20aesthetic&width=120&height=120&seq=avatar-comment-03&orientation=squarish',
    name: '深夜追更人',
    time: '昨天',
    content: '从国漫区一路看到韩漫区，这个网站的漫画资源真的太全了！下拉式阅读真的很方便，晚上躺在床上单手就能刷，画质也超清晰。',
    work: '在读《斗破苍穹》',
  },
];

export const rankingData = [
  { rank: 1, title: '傀儡', tag: '悬疑', heat: '本周最热', change: 'up' },
  { rank: 2, title: '秘密教学', tag: '恋爱', heat: '热度爆表', change: 'up' },
  { rank: 3, title: '继母的朋友们', tag: '剧情', heat: '持续上升', change: 'up' },
  { rank: 4, title: '健身教练', tag: '都市', heat: '新晋热门', change: 'new' },
  { rank: 5, title: '女神狩猎', tag: '奇幻', heat: '稳步攀升', change: 'up' },
];

export const appData = {
  title: '手机随时随地看漫画',
  description: '无需下载APP，手机浏览器直接打开即可畅享高清漫画。支持iOS和Android，下拉式阅读体验完美适配移动端，随时随地追更不耽误。',
  features: ['免安装即点即看', '移动端专属优化', '省流量高清模式', '阅读进度自动保存'],
};

export const topicsData = [
  { name: '韩漫推荐', count: 1280, href: '#ranking' },
  { name: '日漫经典', count: 960, href: '#carousel' },
  { name: '国漫崛起', count: 750, href: '#cards' },
  { name: '悬疑剧情', count: 620, href: '#index' },
  { name: '恋爱甜漫', count: 890, href: '#ranking' },
  { name: '奇幻冒险', count: 560, href: '#index' },
  { name: '都市日常', count: 480, href: '#cards' },
  { name: '热血格斗', count: 430, href: '#carousel' },
  { name: '下拉式爽文', count: 1100, href: '#features' },
  { name: '完结佳作', count: 350, href: '#index' },
];

export const carouselData = [
  {
    title: '韩漫精选：2026上半年必看神作',
    description: '盘点上半年口碑炸裂的韩漫作品，从悬疑到恋爱，每部都是不可错过的经典。画风精美、剧情在线，让你一口气追到最新话。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20manga%20themed%20illustration%20with%20warm%20atmospheric%20lighting%20and%20soft%20gradients%2C%20stylish%20comic%20art%20aesthetic%20with%20flowing%20composition%2C%20rich%20warm%20color%20palette%20of%20coral%20amber%20and%20cream%20tones%2C%20minimalist%20background%20with%20gentle%20texture%2C%20editorial%20art%20style%20with%20captivating%20mood&width=640&height=360&seq=carousel-01&orientation=landscape',
    tag: '编辑精选',
  },
  {
    title: '日漫经典：那些年追过的神番',
    description: '《进击的巨人》《鬼灭之刃》《咒术回战》等经典日漫全篇收录，重温那些热血与感动的瞬间。高清画质还原原版体验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20Japanese%20manga%20style%20art%20illustration%20with%20warm%20dramatic%20lighting%2C%20action%20comic%20aesthetic%20with%20flowing%20motion%20lines%2C%20rich%20amber%20and%20coral%20warm%20color%20palette%2C%20minimalist%20gradient%20background%20with%20artistic%20texture&width=640&height=360&seq=carousel-02&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '国漫崛起：不可错过的国产精品',
    description: '国漫近年来佳作频出，《斗破苍穹》《完美世界》《一念永恒》等作品画风精良、剧情扎实，展现国产漫画实力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20style%20manga%20illustration%20with%20warm%20atmospheric%20lighting%2C%20traditional%20art%20aesthetic%20blended%20with%20modern%20comic%20style%2C%20soft%20warm%20coral%20and%20cream%20tones%2C%20minimalist%20background%20with%20brush%20stroke%20texture&width=640&height=360&seq=carousel-03&orientation=landscape',
    tag: '国漫之光',
  },
  {
    title: '悬疑专区：烧脑剧情层层反转',
    description: '《傀儡》《陷阱》《迷局》等悬疑漫画带你体验烧脑之旅。每一个分镜都可能隐藏线索，考验你的推理能力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Suspenseful%20manga%20style%20illustration%20with%20moody%20warm%20lighting%2C%20mystery%20comic%20art%20aesthetic%20with%20dramatic%20shadows%2C%20rich%20amber%20and%20dark%20coral%20tones%2C%20minimalist%20gradient%20background%20with%20atmospheric%20texture&width=640&height=360&seq=carousel-04&orientation=landscape',
    tag: '悬疑精选',
  },
  {
    title: '恋爱甜漫：那些令人心动的瞬间',
    description: '《秘密教学》《邻家姐姐》《恋爱播放列表》等甜度爆表的恋爱漫画，细腻描绘每一份心动。看完只想说：太甜了！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20style%20illustration%20with%20soft%20warm%20lighting%2C%20sweet%20comic%20art%20aesthetic%20with%20gentle%20pink%20and%20coral%20tones%2C%20dreamy%20atmosphere%20on%20minimalist%20gradient%20background%2C%20artistic%20editorial%20style&width=640&height=360&seq=carousel-05&orientation=landscape',
    tag: '甜蜜推荐',
  },
];

export const aboutData = {
  title: '关于羞羞漫画',
  description: '羞羞漫画网创建于2020年，是国内领先的韩漫、日漫、国漫综合在线免费阅读平台。我们致力于为漫画爱好者提供最全面、最便捷的在线阅读体验，平台收录超过5000部漫画作品，涵盖悬疑、恋爱、奇幻、都市、热血等多种类型，日均更新200余话，服务超过800万漫画读者。',
  features: [
    { icon: 'ri-shield-check-line', text: '资源全面：韩漫、日漫、国漫一站式覆盖' },
    { icon: 'ri-flashlight-line', text: '更新及时：热门作品每日同步官方最新话' },
    { icon: 'ri-device-line', text: '体验优秀：下拉式阅读，移动端专属优化' },
    { icon: 'ri-user-heart-line', text: '用户至上：完全免费，无需注册即刻畅读' },
  ],
};

export const cardsData = [
  {
    title: '《傀儡》',
    description: '年度悬疑韩漫天花板，反转剧情令人窒息。当主角发现自己生活在一个巨大的谎言中，真相远比想象更加残酷。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20cover%20style%20illustration%20with%20warm%20atmospheric%20lighting%2C%20beautiful%20character%20art%20with%20soft%20shadows%2C%20minimalist%20composition%20on%20simple%20warm%20toned%20background%2C%20artistic%20digital%20painting%20style%20with%20rich%20coral%20and%20cream%20colors%2C%20editorial%20quality%20with%20captivating%20mood&width=600&height=750&seq=card-01&orientation=portrait',
    tag: '悬疑',
    stat: '热度 9.8',
  },
  {
    title: '《秘密教学》',
    description: '恋爱韩漫经典之作，画风细腻情感真挚。一段不该开始的感情，却在相处中逐渐失控，引发无数读者共鸣。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20cover%20style%20illustration%20with%20soft%20warm%20lighting%2C%20beautiful%20character%20portrait%20art%20with%20gentle%20expression%2C%20minimalist%20composition%20on%20warm%20cream%20background%2C%20artistic%20digital%20painting%20style%20with%20coral%20and%20peach%20tones&width=600&height=750&seq=card-02&orientation=portrait',
    tag: '恋爱',
    stat: '热度 9.7',
  },
  {
    title: '《健身教练》',
    description: '都市韩漫高人气连载，健身房里的故事精彩纷呈。身材管理加情感纠葛，每一话都让读者热血沸腾。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20manga%20cover%20style%20illustration%20with%20warm%20energetic%20lighting%2C%20fitness%20themed%20character%20art%20with%20athletic%20aesthetic%2C%20minimalist%20composition%20on%20warm%20toned%20background%2C%20artistic%20digital%20painting%20with%20amber%20and%20coral%20colors&width=600&height=750&seq=card-03&orientation=portrait',
    tag: '都市',
    stat: '热度 9.5',
  },
  {
    title: '《女神狩猎》',
    description: '奇幻题材韩漫力作，世界观设定宏大精彩。主角在异世界中成长历练，剧情层层深入引人入胜。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20cover%20style%20illustration%20with%20dramatic%20warm%20lighting%2C%20epic%20character%20art%20with%20dynamic%20composition%2C%20minimalist%20background%20with%20golden%20accents%2C%20artistic%20digital%20painting%20style%20with%20rich%20amber%20and%20coral%20tones&width=600&height=750&seq=card-04&orientation=portrait',
    tag: '奇幻',
    stat: '热度 9.4',
  },
  {
    title: '《继母的朋友们》',
    description: '剧情向韩漫热门作品，家庭与情感的复杂交织。细腻描绘每个角色的内心世界，读者好评如潮。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Emotional%20manga%20cover%20style%20illustration%20with%20warm%20intimate%20lighting%2C%20family%20drama%20themed%20character%20art%20with%20expressive%20features%2C%20minimalist%20composition%20on%20soft%20warm%20background%2C%20artistic%20digital%20painting%20with%20gentle%20coral%20and%20cream%20colors&width=600&height=750&seq=card-05&orientation=portrait',
    tag: '剧情',
    stat: '热度 9.3',
  },
  {
    title: '《斗破苍穹》',
    description: '国漫年度力作，玄幻题材巅峰之作。精美国风画面配合热血剧情，国产漫画的标杆级作品。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20style%20manga%20cover%20illustration%20with%20dramatic%20warm%20lighting%2C%20martial%20arts%20themed%20character%20art%20with%20flowing%20robes%2C%20minimalist%20golden%20gradient%20background%2C%20artistic%20digital%20painting%20with%20rich%20amber%20and%20coral%20tones&width=600&height=750&seq=card-06&orientation=portrait',
    tag: '玄幻',
    stat: '热度 9.2',
  },
];

export const faqData = [
  {
    question: '羞羞漫画网需要付费吗？',
    answer: '完全不需要！羞羞漫画网所有漫画资源均为免费阅读，无需注册登录，打开网站即可畅享高清漫画阅读体验。我们致力于为漫画爱好者提供永久免费的阅读服务。',
  },
  {
    question: '如何找到最新更新的漫画？',
    answer: '你可以通过首页的"最新快讯"板块查看每日更新动态，也可以在"热门榜单"中浏览当前热度最高的连载作品。韩漫、日漫、国漫各自有独立专区，通过"主题索引"可以快速定位你感兴趣的类型。',
  },
  {
    question: '手机上看漫画体验怎么样？',
    answer: '非常好！我们专门为移动端优化了下拉式阅读体验，手机浏览器直接打开网站就能畅享丝滑阅读。无需下载任何APP，支持iOS和Android系统，高清画质自动适配屏幕尺寸，单手操作也毫无压力。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '平台每日同步更新热门连载漫画的最新话，日均更新量超过200话。韩漫、日漫、国漫各自按照官方更新节奏同步上线，确保读者能第一时间追到最新内容。"最新快讯"板块会实时推送更新信息，方便你掌握更新动态。',
  },
];

export const footerNavLinks = [
  { label: '手机阅读', href: '#app' },
  { label: '热门推荐', href: '#cards' },
  { label: '常见问题', href: '#faq' },
  { label: '精彩推荐', href: '#media' },
  { label: '焦点专题', href: '#carousel' },
];